module.exports = __webpack_public_path__ + "img/u5.d1891d23.svg";